var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35289 1.41301C3.96237 1.80353 3.96237 2.4367 4.35289 2.82722L9.58579 8.06012L4.35289 13.293C3.96237 13.6835 3.96237 14.3167 4.35289 14.7072C4.74342 15.0977 5.37658 15.0977 5.76711 14.7072L11.7071 8.76722C12.0976 8.3767 12.0976 7.74353 11.7071 7.35301L5.76711 1.41301C5.37658 1.02249 4.74342 1.02249 4.35289 1.41301Z",
    fill: "#234596"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjM1Mjg5IDEuNDEzMDFDMy45NjIzNyAxLjgwMzUzIDMuOTYyMzcgMi40MzY3IDQuMzUyODkgMi44MjcyMkw5LjU4NTc5IDguMDYwMTJMNC4zNTI4OSAxMy4yOTNDMy45NjIzNyAxMy42ODM1IDMuOTYyMzcgMTQuMzE2NyA0LjM1Mjg5IDE0LjcwNzJDNC43NDM0MiAxNS4wOTc3IDUuMzc2NTggMTUuMDk3NyA1Ljc2NzExIDE0LjcwNzJMMTEuNzA3MSA4Ljc2NzIyQzEyLjA5NzYgOC4zNzY3IDEyLjA5NzYgNy43NDM1MyAxMS43MDcxIDcuMzUzMDFMNS43NjcxMSAxLjQxMzAxQzUuMzc2NTggMS4wMjI0OSA0Ljc0MzQyIDEuMDIyNDkgNC4zNTI4OSAxLjQxMzAxWiIgZmlsbD0iIzIzNDU5NiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };